import { useEffect, useState } from 'react';

export const useElapsedTime = (isSending: boolean) => {
  const [finishedAt, setFinishedAt] = useState(0);
  const [elapsedTime, setElapsedTime] = useState(0);

  useEffect(() => {
    // eslint-disable-next-line no-undef
    let timerId: NodeJS.Timeout | null = null;

    if (isSending) {
      setElapsedTime(0);

      timerId = setInterval(() => {
        setElapsedTime(prevTime => prevTime + 1);
      }, 1000);
    } else if (timerId) {
      clearInterval(timerId);
    }

    return () => {
      if (timerId) {
        clearInterval(timerId);
      }

      setFinishedAt(Date.now());
    };
  }, [isSending]);

  return {
    elapsedTime,
    finishedAt,
  };
};
